import { createBrowserRouter } from 'react-router-dom';

import App from '@/App';
import ProtectedRoute from '@/components/ProtectedRoute';
import PublicRoute from '@/components/PublicRoute';

import LoginLayout from '@/layouts/Login';
import DashboardLayout from '@/layouts/Dashboard';
import RegistrationLayout from '@/layouts/Registration';
import OnboardingLayout from '@/layouts/Onboarding';
import NotFoundLayout from '@/layouts/NotFound';
import DealErrorMessageLayout from '@/layouts/DealErrorMessage';
import WafBlockedLayout from '@/layouts/WafBlocked';

import LoginView from '@/pages/login/LoginView';

import RegistrationView from '@/pages/registration/RegistrationView';

import OnboardingView from '@/pages/onboarding/OnboardingView';

import MainView from '@/pages/dashboard/main/MainView';
import SkillView from '@/pages/dashboard/skill/SkillView';
import QuizView from '@/pages/dashboard/quiz/QuizView';
import LevelTestView from '@/pages/dashboard/initial-level-test/LevelTestView';
import NoLevelAssignedView from '@/pages/dashboard/no-level-assigned/NoLevelAssignedView';
import NotFound from '@/pages/not-found/NotFound';
import Games from '@/pages/dashboard/main/Games';
import MyStudents from '@/pages/dashboard/main/MyStudents';
import StudentMetricsDashboard from '@/pages/dashboard/StudentMetricsDashboard/StudentMetricsDashboard';
import Profile from '@/pages/dashboard/main/Profile';
import MyClasses from '@/pages/dashboard/main/MyClasses';
import MyClassDetailView from '@/pages/dashboard/my-classes/MyClassDetailView';
import EditClassFormPage from '@/components/school-management/SchoolDetailsPage/EditClassFormPage';
import MyPrivateTutor from '@/pages/dashboard/my-private-tutor/MyPrivateTutor';
import TutorChat from '@/pages/dashboard/tutor-chat/TutorChat';
import DealErrorMessage from '@/pages/deal-error-message/DealErrorMessage';
import WafBlocked from '@/pages/waf-blocked/WafBlocked';
import RouterError from '@/pages/router-error/RouterError';

export enum ROUTE_NAMES {
  LOGIN = 'login',
  REGISTRATION = 'registration',
  ONBOARDING = 'onboarding',
  GAMES = 'games',
  LEVEL_TEST = 'levelTest',
  SKILL = 'skill',
  QUIZ = 'quiz',
  MY_STUDENTS = 'myStudents',
  MY_CLASSES = 'myClasses',
  PROFILE = 'profile',
  MY_TUTOR = 'myTutor',
  TUTOR_CHAT = 'myTutorChat',
  NOT_FOUND = 'notFound',
  DEAL_ERROR_MESSAGE = 'dealErrorMessage',
  WAF_BLOCKED = 'wafBlocked',
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <RouterError />,
    children: [
      {
        path: 'login',
        element: <PublicRoute children={<LoginLayout />} />,
        children: [
          {
            path: '',
            element: <LoginView />,
          },
        ],
      },
      {
        path: 'registration/:role',
        element: <PublicRoute children={<RegistrationLayout />} />,
        children: [
          {
            path: '',
            element: <RegistrationView />,
          },
        ],
      },
      {
        path: 'onboarding',
        element: <ProtectedRoute isAdminAllowed children={<OnboardingLayout />} />,
        children: [
          {
            path: '',
            element: <OnboardingView />,
          },
        ],
      },
      {
        path: 'dashboard',
        element: <ProtectedRoute children={<DashboardLayout />} />,
        children: [
          {
            path: '',
            element: <MainView />,
            children: [
              {
                path: 'games',
                element: <Games />,
              },
              {
                path: 'my-students',
                element: <StudentMetricsDashboard />,
              },
              {
                path: 'my-classes/edit-class/:classId',
                element: <EditClassFormPage />,
              },
              {
                path: 'my-classes/:classId',
                element: <MyClassDetailView />,
              },
              {
                path: 'my-classes',
                element: <MyClasses />,
              },
              {
                path: 'profile',
                element: <Profile />,
              },
              {
                path: 'my-tutor',
                element: <MyPrivateTutor />,
              },
              {
                path: 'my-tutor-chat',
                element: <TutorChat />,
              },
            ],
          },
          {
            path: 'level-test',
            element: <LevelTestView />,
          },
          {
            path: 'no-level-assigned',
            element: <NoLevelAssignedView />,
          },
          {
            path: 'skill/:type',
            element: <SkillView />,
          },
          {
            path: 'quiz',
            element: <QuizView />,
          },
        ],
      },
      {
        path: 'not-found',
        element: <PublicRoute children={<NotFoundLayout />} />,
        children: [
          {
            path: '',
            element: <NotFound />,
          },
        ],
      },
      {
        path: 'deal-error-message',
        element: <PublicRoute children={<DealErrorMessageLayout />} />,
        children: [
          {
            path: '',
            element: <DealErrorMessage />,
          },
        ],
      },
      {
        path: 'waf-blocked',
        element: <PublicRoute children={<WafBlockedLayout />} />,
        children: [
          {
            path: '',
            element: <WafBlocked />,
          },
        ],
      },
      // Placeholder for Admin section routing
      {
        path: '*',
        element: <div style={{ display: 'none' }} />,
      },
    ],
  },
]);

export default router;
